export const If = ({ cond, children }) => (!!cond ? children : null);
